import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";
import AboutPage from "@/pages/AboutPage";
import AdminPage from "@/pages/AdminPage";
import BookingPage from "@/pages/BookingPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import HomePage from "@/pages/HomePage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import LegalPage from "@/pages/LegalPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ServicesPage from "@/pages/ServicesPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function NotFound() {
  return <main className="page-main"><section className="page-intro container"><span className="eyebrow">404</span><h1>Esta página<br /><em>não existe.</em></h1><a href="/" className="button" data-testid="not-found-home-link">Voltar ao início</a></section></main>;
}

function Site() {
  return <><ScrollToTop /><SiteHeader /><Routes><Route path="/" element={<HomePage />} /><Route path="/servicos" element={<ServicesPage />} /><Route path="/servicos/:slug" element={<ServiceDetailPage />} /><Route path="/como-funciona" element={<HowItWorksPage />} /><Route path="/sobre-nos" element={<AboutPage />} /><Route path="/faq" element={<FaqPage />} /><Route path="/contactos" element={<ContactPage />} /><Route path="/marcar-servico" element={<BookingPage />} /><Route path="/admin" element={<AdminPage />} /><Route path="/:type" element={<LegalPage />} /><Route path="*" element={<NotFound />} /></Routes><Footer /></>;
}

export default function App() {
  return <BrowserRouter><Site /></BrowserRouter>;
}
